/**
 * Comprehensive list of musical instruments for dropdown selection
 */
const instrumentsData = [
  // String instruments
  'Acoustic Guitar',
  'Electric Guitar',
  'Bass Guitar',
  'Violin',
  'Viola',
  'Cello',
  'Double Bass',
  'Harp',
  'Banjo',
  'Mandolin',
  'Ukulele',
  
  // Keyboard instruments
  'Piano',
  'Keyboard',
  'Organ',
  'Synthesizer',
  'Accordion',
  'Melodica',
  
  // Wind instruments
  'Flute',
  'Clarinet',
  'Saxophone',
  'Alto Saxophone',
  'Tenor Saxophone',
  'Baritone Saxophone',
  'Soprano Saxophone',
  'Oboe',
  'Bassoon',
  'Recorder',
  
  // Brass instruments
  'Trumpet',
  'Trombone',
  'French Horn',
  'Tuba',
  'Euphonium',
  'Cornet',
  
  // Percussion instruments
  'Drums',
  'Drum Kit',
  'Cajon',
  'Bongos',
  'Congas',
  'Djembe',
  'Tambourine',
  'Xylophone',
  'Vibraphone',
  'Marimba',
  'Timpani',
  'Triangle',
  'Cymbals',
  'Maracas',
  'Cowbell',
  
  // Electronic instruments
  'DJ Turntables',
  'Drum Machine',
  'Sampler',
  'MIDI Controller',
  'Theremin',
  
  // Vocal
  'Vocals',
  'Lead Vocals',
  'Backing Vocals',
  'Beatboxing',
  
  // Other
  'Harmonica',
  'Bagpipes',
  'Sitar',
  'Tabla',
  'Didgeridoo',
  'Kalimba',
  'Ocarina',
  'Handpan',
];

export default instrumentsData;
